import httpClient from "../httpClient";
import { API_CASE_STATUS_SET } from "../config";

const caseStatus = {
    create: (data) => httpClient.post(API_CASE_STATUS_SET, data),
};

export default caseStatus;
